module.exports = __webpack_public_path__ + "static/img/fish.d3bc1904.png";